import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IGetAllLogReajusteContratoFinanceiroUseCase } from "../../../presentation/useCases/read/get_all_log_reajuste_contrato_financeiro_use_case";
import { LogReajusteContratoFinanceiro } from "../../models/log_reajuste_contrato_financeiro";
import { IFinanceiroRepository } from "../../repositories/financeiro_repositories";

/**
 * GetAllLogReajusteContratoFinanceiroUseCase
 */

export class GetAllLogReajusteContratoFinanceiroUseCase extends BasePaginatedUseCase<LogReajusteContratoFinanceiro> implements IGetAllLogReajusteContratoFinanceiroUseCase {
  constructor(private readonly repository: IFinanceiroRepository) {
    super();
  }

  async getAllLogReajusteContratoFinanceiro(
    idContratoFinanceiro: number,
    currentPage?: number,
    rowsPerPage?: number
  ): Promise<void> {
    const result = await this.repository.getAllLogReajusteContratoFinanceiro(
      idContratoFinanceiro,
      currentPage,
      rowsPerPage
    );

    this._items = result.items;
    this._currentPage = result.currentPage;
    this._pageSize = result.pageSize;
    this._totalItems = result.totalItems;
    this._totalPages = result.totalPages;
  }

}
